export const ActionTypes = {
  LOADING: "ASSIGN_OPTION_LOADING",
  ERROR: "ASSIGN_OPTION_ERROR",
  SUCCESS: "ASSIGN_OPTION_SUCCESS",
};
